<template>
  <div class="content ht-100v pd-0">
    <main-header txt="Тээврийн хэрэгсэл / Статистик" />
    <div class="content-body">
      <div class="container pd-0-f">
        <div class="card">
          <div class="card-body">
            <table class="table table-bordered table-striped table-sm">
              <thead class="bg-gray-300">
                <tr>
                  <th class="text-center" >Камер</th>
                  <th class="text-center" v-for="(t, ti) in 24" :key="ti">{{t-1}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(l, i) in cameras" :key="i">
                  <td>{{ l }}</td>
                  <td class="text-right tx-11" v-for="(t, tt) in 24" :key="`${tt}_i`">
                    {{getCnt(l,t-1)}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";

export default {
  components:{
    mainHeader: () => ({
      component: import("@/views/apps/penalty/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data(){
    return{
      cameras: [],
      list: []
    }
  },
  mounted(){
    this.loadVehicle();
  },
  methods:{
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    getUniqueValues(array, key) {
      var result = new Set();
      array.forEach(function(item) {
          if (item.hasOwnProperty(key)) {
              result.add(item[key]);
          }
      });
      return result;
    },
    loadVehicle(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TrafficData/hzbhInTrafficVehicle" },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.list= res.data.list;
          var cmrs = this.getUniqueValues(res.data.list,'cameraName')
          //console.log('res', res, cmrs);
          this.cameras= cmrs;
        }
      });

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TrafficData/hzbhInTrafficVehicle" },
        data:{ mode:1 },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('res', res);
        }
      });
    },
    getCnt(cname, hour){
      let rv=0;
      if(this.list.filter(x=>x.cameraName==cname && x.hour==hour).length>0){
        rv= this.list.filter(x=>x.cameraName==cname && x.hour==hour)[0].count;
      }else{
        rv=0;
      }
      return rv;
    },
  }
}
</script>

<style>

</style>